import { Carrier } from './../carrier/carrier';
import { LabMDM } from '../masterdata/models/lab';
export class NGSWorkfileRequest {
  lab: LabMDM;
  barcode: string;
  numberOfMeasureMents: number;
  carrierList: Carrier[];
  userId: string;
  workfileName: string;
  barcodeMeasurementIdMap: any;
}
